export default __webpack_public_path__ + "media/harmonyVid.d5a6178d.mp4";